/**
 * ¿El número resuelto es enviable por WhatsApp?
 *
 * Un lead sin número principal resuelve el destinatario como el prefijo pelado
 * (p. ej. "+34" = prefijo por defecto + número vacío). Esos envíos degeneran en
 * un chat fantasma sin contacto ("Sin nombre") que aglutina a varios negocios.
 * Para evitarlo exigimos un número REAL: "+" seguido de al menos 8 dígitos
 * (prefijo de país + abonado), no solo el código de marcación.
 *
 * @param {string|null|undefined} phone número en formato E.164 (con prefijo)
 * @returns {boolean}
 */
export function isSendablePhone(phone) {
  if (typeof phone !== "string") return false;
  const trimmed = phone.trim();
  if (!trimmed.startsWith("+")) return false;
  const digits = trimmed.replace(/\D+/g, "");
  return digits.length >= 8;
}
